import { EnumOptions } from '@kinet-open-network/shared/data-access/model';

/**
 * Project-specific (PBGAS) notification types.
 * These are registered at runtime and augmented at the type level.
 */
export enum PbgasNotificationType {}

export const pbgasNotificationTypes = Object.values(PbgasNotificationType);

export const pbgasNotificationTypeOptions = new Map<string, EnumOptions>();

// Module augmentation — makes pbgas notification types valid at compile time
declare module '@kinet-open-network/shared/data-access/model' {
  interface NotificationTypeExtensions {
    pbgas: PbgasNotificationType;
  }
}
